<template>
  <div>
    <div v-show="!isLoading" class="content_cell">
      <div class="row">
        <div class="col-md-6">
          <div class="p_title">學生進度</div>
          <div class="p_info">班級編號: {{courseCode}}</div>
          <div class="p_info">學生人數: {{students.length}}</div>
        </div>
        <div class="col-md-6">
          <div class="btn btn-success btn-fill" style="float: right;">
            <a target="_blank" :href="`${this.$store.getters.api_url}courses/${this.course_id}/progress?type=csv`" style="color: white;">下載CSV檔案</a>
          </div>
        </div>
      </div>
      <div style="width: 100%; overflow-x: auto;">
        <table border="1" id="table" style="width: 100%;">
          <thead style="background-color:rgb(122, 189, 122); color:white;">
            <tr>
              <th style="min-width: 150px;">學生</th>
              <th v-for="activity in sortedActivities" :key="activity.id" style="min-width: 150px;">{{activity.name}}
                <div v-if="activity.type === 'Video'">(影片)</div>
                <div v-if="activity.type !== 'Video'">(習作)</div>
              </th>
              <th v-if="sortedActivities.length === 0" style="min-width: 150px;">(暫無任務)</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr v-for="student in sortedStudents" :key="student.id">{{student.name}}</tr> -->
            <GradebookCell v-for="student in sortedStudents" :key="student.id" :student="student" :activities="sortedActivities" />
          </tbody>
        </table>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style scoped>
.content_cell {
    width:95%;
    -moz-box-shadow: 0 0 5px #8DD;
    -webkit-box-shadow: 0 0 5px #8DD;
    box-shadow: 0 0 5px #8DD;
    background-color: #fff;
    padding: 28px;
    border-radius: 11px;
    font-size: 15pt;
    font-weight: bold;
    color: rgb(142, 202, 147);
    margin-left: 12px;
}
.std_title {
    background-color:rgb(122, 189, 122);
    color:white;
    text-align:center;
}
.std_list {
    font-size:11pt;
    font-weight:lighter;
    color: rgb(158, 160, 163);
}
.p_title {
    color:rgb(136, 140, 143);
    font-size:16pt;
    line-height: 1.8;
}
.p_info {
    font-size:11pt;
    font-weight:lighter;
}
.p_setting {
    text-align: right;
    font-size:11pt;
    font-weight:lighter;
}
.p_setting > a {
    color:red;
}
#table {
  margin: 10px 0;
}
#table td{
  padding: 10px 0;
}
#table th{
  padding: 10px;
  text-align:center;
}
</style>
<script>
import Loading from '@/components/Utility/Loading.vue'
import GradebookCell from '@/components/Gradebook/GradebookCell.vue'
export default {
  data () {
    return {
      isLoading: true,
      course_id: parseInt(this.$route.query.course),
      students: [],
      activities: [],
      courseCode: ''
    }
  },
  computed: {
    sortedStudents () {
      return this.students.slice(0).sort((a, b) => a.name < b.name ? -1 : 1)
    },
    sortedActivities () {
      return this.activities.slice(0).sort((a, b) => a.id < b.id ? -1 : 1)
    }
  },
  components: {
    Loading,
    GradebookCell
  },
  async created () {
    await this.$store.dispatch('request', {
      route: 'courses/' + this.course_id + '/report'
    }).then(r => {
      console.log(r)
      r.weeks.forEach((value) => {
        value.activities.forEach((value) => {
          // console.log(value)
          this.activities.push(value)
        })
      })
    })
    await this.$store.dispatch('request', {
      route: `courses/${this.course_id}/progress`
    }).then(r => {
      // console.log(r)
      let students = Object.keys(r).map((key) => {
        return r[key]
      })
      console.log(students)
      this.students = students
    })
    await this.$store.dispatch('request', {
      route: `courses/${this.course_id}`
    }).then(res => {
      this.courseCode = res.code
    })
    this.isLoading = false
  }
}
</script>
